<template>
  <div class="common-layout">
    <el-container>
      <div class="top">{{ orgName }}</div>
      <div class="nav">
        <div class="nav-title">党务服务</div>
        <el-row class="first">
          <el-col :span="6">
            <div class="icon icon-clickable" @click="goPartyFeePay">
              <img class="icon-img" src="@/assets/img/org/fee.png" alt="党费缴纳" />
              <span>党费缴纳</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="icon icon-clickable" @click="goOrgTransfer">
              <img class="icon-img" src="@/assets/img/org/transfer.png" alt="组织转接" />
              <span>组织转接</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="icon icon-clickable" @click="goMeetingList">
              <img class="icon-img" src="@/assets/img/org/meeting.png" alt="三会一课" />
              <span>三会一课</span>
            </div>
          </el-col>
          <!-- <el-col :span="6">
            <div class="icon icon-clickable" @click="goMicroWish">
              <img class="icon-img" src="@/assets/img/org/weixinyuan.png" alt="微心愿" />
              <span>微心愿</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="6">
            <div class="icon">
              <el-icon size="9.23077vw">
                <Platform />
              </el-icon>
              <span>政治生日</span>
            </div>
          </el-col> -->
        </el-row>
      </div>
      <div class="nav vr-nav">
        <div class="nav-title">VR党建</div>
        <el-row class="first">
          <el-col :span="6">
            <div class="icon icon-clickable" @click="goActivitySpace">
              <img class="icon-img" src="@/assets/img/org/conference-hall.png" alt="支部活动空间" />
              <span>元宇宙空间</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="icon icon-clickable" @click="goMetaverseMeetingHall">
              <img class="icon-img" src="@/assets/img/org/meeting2.png" alt="元宇宙会议厅" />
              <span>元宇宙会议厅</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-footer>
        <BottomNav />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import BottomNav from '../component/BottomNav.vue';
import { getUserProfile } from '@/api';
import { getToken } from '@/utils/auth';
import { getCachedUserProfile, setCachedUserProfile } from '@/utils/profile';

const META_BASE_URL_MAP = {
  test: 'http://www.dangjian.com',
  prod: 'https://aidj.gee.cn'
};

export default {
  name: 'OrganizePage',
  data() {
    return {
      profileData: getCachedUserProfile()
    };
  },
  components: {
    BottomNav
  },
  computed: {
    orgName() {
      return this.profileData?.info?.org_name || '--';
    }
  },
  mounted() {
    if (!this.profileData?.info?.id) {
      this.fetchUserProfile();
    }
  },
  methods: {
    getMetaBaseUrl() {
      const env = process.env.VUE_APP_API_ENV || 'local';
      return META_BASE_URL_MAP[env] || META_BASE_URL_MAP.prod;
    },
    goPartyFeePay() {
      this.$router.push('/organize/party-fee');
    },
    goOrgTransfer() {
      this.$router.push('/organize/transfer/detail');
    },
    goMeetingList() {
      this.$router.push('/organize/meeting');
    },
    // goMicroWish() {
    //   this.$router.push('/organize/microwish');
    // },

    goActivitySpace() {
      const token = getToken();
      window.location.href = `${this.getMetaBaseUrl()}/meta/meta2/select_role.html?access-token=${encodeURIComponent(token)}`;
    },
    goMetaverseMeetingHall() {
      const token = getToken();
      window.location.href = `${this.getMetaBaseUrl()}/meta/meta2/select_role.html?access-token=${encodeURIComponent(token)}&meeting=1`;
    },
    async fetchUserProfile() {
      try {
        const res = await getUserProfile();
        const payload = res?.data || null;
        if (payload) {
          this.profileData = payload;
          setCachedUserProfile(payload);
        }
      } catch (error) {
        // 错误提示已在全局请求拦截器中统一处理
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  display: flex;
  align-items: center;
  padding-left: 5.12821vw;
  position: relative;
  top: 3.8vw;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 10.25641vw;
  background: #ff6060;
  border-radius: 5.12821vw;
  color: white;
  font-size: 3.58974vw;
}

.nav {
  position: relative;
  width: 90%;
  margin: 8vw auto 0;
  padding: 5.12821vw 0 6.15385vw;
  background: white;
  border-radius: 3.84615vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);

  .nav-title {
    margin-left: 5.12821vw;
    font-size: 4.61538vw;
    font-weight: bold;
  }

  .first {
    width: 100%;
    margin-top: 5vw;
  }

  .icon {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1.53846vw;

    .icon-img {
      width: 18vw;
      height: 14vw;
      object-fit: contain;
    }

    span {
      width: 4em;
      display: block;
      text-align: center;
      font-size: 3.33333vw;
      line-height: 1.4;
      white-space: normal;
      word-break: break-all;
    }
  }

  .icon-clickable {
    cursor: pointer;
  }
}

.vr-nav {
  margin-top: 5vw;
}
</style>